import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import withStore from '../../components/withStore';
import ActiveQuotes from '../../components/Quotes/ActiveQuotes';

function mapStateToProps(state) {
  const { isGoogleMapsApiLoaded } = state.googleMap;
  const { isAirportByIdLoading, visitedAirportsFinder, error } = state.visitedAirports;
  const { isQuoteLoading, isQuoteLoadMoreLoading, activeQuotes, quoteError } = state.quotes;
  const { user } = state.user;
  const { aircraftsList } = state.aircrafts;
  return {
    user,
    isAirportByIdLoading,
    visitedAirportsFinder,
    isGoogleMapsApiLoaded,
    isQuoteLoading,
    isQuoteLoadMoreLoading,
    quotes: activeQuotes,
    error: quoteError,
    airportError: error,
    aircraftsList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAirportById: id => dispatch(actions.getAirportById(id)),
    onGoogleMapsApiLoaded: () => dispatch(actions.onGoogleMapsApiLoaded()),
    fetchQuotes: (quoteType, pageNum) => dispatch(actions.fetchQuotes(quoteType, pageNum)),
  };
}

const ActiveQuotesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActiveQuotes);

export default withStore(ActiveQuotesContainer);
